<template>
  <div>
    <a-toolbar
      class="pl-4"
      :class="{
        'primary-gradient': section !== 'calendar',
        'grey-gradient': section === 'calendar',
      }"
    >
      <v-icon left :dark="section !== 'calendar'"> mdi-label-variant </v-icon
      ><span class="widget-title">{{
        $t("dashboard.lblUpcomingSurveys")
      }}</span>
      <v-spacer></v-spacer>
    </a-toolbar>

    <!--  <v-row>
      <v-col cols="12" sm="12" md="12" style="border: 1px solid lightgray"> -->
    <v-card
      color="Neutral"
      :elevation="section === 'calendar' ? 1 : 0"
      class="surveypoll-card overflow-y-auto"
      :style="section === 'calendar' ? 'height: 750px' : ''"
    >
      <v-skeleton-loader
        v-if="isSkeleton"
        type="article, article"
      ></v-skeleton-loader>
      <v-card-text v-else>
        <survey-grid
          :items="getSurvey"
          :itemsPerPage="5"
          :shownOnDashboard="true"
        ></survey-grid>
      </v-card-text>
    </v-card>
    <!-- </v-col>
    </v-row> -->
  </div>
</template>

<script>
import SurveyGrid from "../poll/SurveyGrid.vue";
import { mapState, mapActions } from "vuex";
import SignalRMixin from "../../mixin/SignalRMixin";
import AToolbar from "../../wrapper-component/AToolbar.vue";
export default {
  name: "UpcomingMeetingList",
  mixins: [SignalRMixin],
  props: {
    section: {
      type: String,
      default: "dashboard",
    },
  },
  data() {
    return {
      page: 1,
      isloading: false,
      isSkeleton: true,
    };
  },
  components: {
    SurveyGrid,
    AToolbar,
  },
  computed: {
    ...mapState({
      pollSurveyQuestions: (state) => state.poll.pollSurveyQuestions,
    }),
    getSurvey() {
      return this.pollSurveyQuestions.filter((item) => item.type === "survey");
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
  },
  async mounted() {
    this.signalRInit(`surveys_${this.selectedTenant}`);
    if (this.$security.checkUserAccess("ViewSurveyPolls")) {
      await this.getSurveyList();
    }
    setTimeout(() => {
      const childCard = document.getElementsByClassName("surveypoll-card");
      if (childCard.length > 0 && this.section !== "calendar") {
        const height = childCard[0].parentElement.parentElement.offsetHeight;
        if (height) {
          childCard[0].style.height = `${height - 48}px`;
        }
      }
    }, 500);
    this.isSkeleton = false;
  },
  methods: {
    ...mapActions({
      getSurveyList: "poll/getSurveyList",
    }),
    signalRInit(target) {
      this.signalConnection.on(target, async (message) => {
        const result = JSON.parse(message);
        if (result) {
          try {
            await this.getSurveyList();
          } catch (error) {
            console.log(error, "API error");
          }
        }
      });
      if (
        this.signalConnection.connectionState.toLowerCase() === "disconnected"
      ) {
        this.signalConnection.start().catch();
      }
    },
  },
};
</script>
